import { menuItemClasses } from '@mui/material/MenuItem';
import { default as Popover, PopoverOrigin } from '@mui/material/Popover';
import { StyledArrow } from './StyledArrow';
import { MenuPopoverProps } from './types';
import { getPosition } from './utils';

export const CustomPopover = ({
  children,
  arrow = 'top-right',
  hiddenArrow,
  sx,
  ...other
}: MenuPopoverProps) => {
  const { style, anchorOrigin, transformOrigin } = getPosition(arrow);

  return (
    <Popover
      anchorOrigin={anchorOrigin as PopoverOrigin}
      transformOrigin={transformOrigin as PopoverOrigin}
      slotProps={{
        paper: {
          sx: {
            marginTop: 1,
            width: 'auto',
            overflow: 'inherit',
            ...style,
            [`& .${menuItemClasses.root}`]: {
              '& svg': {
                mr: 2,
                flexShrink: 0
              }
            },
            ...sx
          }
        }
      }}
      {...other}
    >
      {!hiddenArrow && <StyledArrow arrow={arrow} />}

      {children}
    </Popover>
  );
};
